export function initHeroParticles() {
  const hero = document.querySelector('[data-hero-particles]');
  if (!hero) return;

  const canvas = hero.querySelector('[data-hero-canvas]');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  let animationId = null;
  const particles = [];

  const createParticle = (width, height) => ({
    x: Math.random() * width,
    y: Math.random() * height,
    vx: (Math.random() - 0.5) * 0.3,
    vy: (Math.random() - 0.5) * 0.3,
    size: Math.random() * 1.5 + 0.5,
    opacity: Math.random() * 0.5 + 0.1,
  });

  const resize = () => {
    const rect = hero.getBoundingClientRect();
    const width = Math.max(1, Math.floor(rect.width));
    const height = Math.max(1, Math.floor(rect.height || window.innerHeight));

    canvas.width = width;
    canvas.height = height;

    const count = Math.floor((width * height) / 15000);
    particles.length = 0;
    for (let i = 0; i < count; i += 1) {
      particles.push(createParticle(width, height));
    }
  };

  const draw = () => {
    const width = canvas.width;
    const height = canvas.height;

    ctx.clearRect(0, 0, width, height);

    for (const p of particles) {
      p.x += p.vx;
      p.y += p.vy;

      if (p.x < 0) p.x = width;
      if (p.x > width) p.x = 0;
      if (p.y < 0) p.y = height;
      if (p.y > height) p.y = 0;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(8, 65%, 53%, ${p.opacity})`;
      ctx.fill();
    }

    for (let i = 0; i < particles.length; i += 1) {
      for (let j = i + 1; j < particles.length; j += 1) {
        const dx = particles[i].x - particles[j].x;
        const dy = particles[i].y - particles[j].y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < 120) {
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.strokeStyle = `hsla(8, 65%, 53%, ${0.08 * (1 - dist / 120)})`;
          ctx.lineWidth = 0.5;
          ctx.stroke();
        }
      }
    }

    animationId = window.requestAnimationFrame(draw);
  };

  resize();
  draw();
  window.addEventListener('resize', resize);

  // Stop animation if this page is cached/swapped by the browser.
  window.addEventListener(
    'pagehide',
    () => {
      window.removeEventListener('resize', resize);
      if (animationId) {
        window.cancelAnimationFrame(animationId);
      }
    },
    { once: true }
  );
}
